import React, { useEffect } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LightboxProps = {
  src: string | null;
  alt: string;
  onClose: () => void;
};
export function Lightbox({
  src,
  alt,
  onClose
}: LightboxProps) {
  const reduce = useReducedMotion();
  useEffect(() => {
    if (!src) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [src, onClose]);
  return <AnimatePresence data-id="element-157" data-mp="2jt4nziwfn3oj">
      {src && <motion.div role="dialog" aria-modal="true" aria-label={alt} className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/80 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: reduce ? 0 : 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} data-id="element-158" data-mp="2xqt8gpml88t2">
          <motion.img src={src} alt={alt} className="max-h-[90vh] max-w-full rounded-xl bg-white object-contain shadow-2xl" initial={{
        scale: 0.96,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.96,
        opacity: 0
      }} transition={{
        duration: reduce ? 0 : 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={e => e.stopPropagation()} data-id="element-159" data-mp="2anynay7hc0h3" />
          <button type="button" onClick={onClose} aria-label="Bezárás" className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white text-ink shadow-md" data-id="element-160" data-mp="2tfragbzvargw">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-161" data-mp="37c4rjk0hoquu" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}